import cn from 'classnames';
import { useContext } from 'react';

import Button from 'components/common/Button';
import { PickYourMealsContext } from 'components/signUpFunnel/Contexts';
import { BrandContext, TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const ThankYouButton = ({
  buttonStyles = 'w-96',
  onClick,
  postSignupUrl,
  user,
  variant = 'default',
}) => {
  const { coreUrl } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);
  const { isPickYourMeals } = useContext(PickYourMealsContext);

  const handleFormSubmit = e => {
    e.preventDefault();
    onClick();
    const form = e.currentTarget;
    const delay = isPickYourMeals ? 500 : 250;
    setTimeout(() => {
      form.submit();
    }, delay);
  };

  const handleButtonClick = () => {
    onClick();
    setTimeout(() => {
      window.location.href = postSignupUrl;
    }, 250);
  };

  if (!user) {
    return null;
  } else if (isTempo) {
    return (
      <form
        action={`${coreUrl}/tempo/signups`}
        method="POST"
        name="signup-completion"
        onSubmit={handleFormSubmit}
      >
        <input name="access_token" type="hidden" value={user.accessToken?.token} />
        <Button
          variation={variant === 'default' ? 'PillOutline' : 'Pill'}
          type="submit"
          className={cn('btn m-auto my-4 flex items-center justify-center', buttonStyles)}
        >
          {isPickYourMeals ? 'Complete Account Setup' : 'Select Meals'}
        </Button>
      </form>
    );
  } else {
    return (
      <Button
        variation={variant === 'default' ? 'PillOutline' : 'Pill'}
        className={cn('btn m-auto my-4 flex items-center justify-center', buttonStyles)}
        onClick={handleButtonClick}
      >
        Select Meals
      </Button>
    );
  }
};

ThankYouButton.propTypes = {
  user: PropTypes.oneOfType([
    PropTypes.shape({
      accessToken: PropTypes.shape({ token: PropTypes.string.isRequired }).isRequired,
    }),
    () => null,
  ]),
  buttonStyles: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  postSignupUrl: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'primary']),
};

export default ThankYouButton;
